import { h } from 'preact'
import { connect } from 'unistore/preact'
import { BasicDialog, RadioButton, SpacerVertical } from '@sodra/bongo-ui'

import { uploadPhotoToPoint } from '../../../actions'
import { useEffect, useState } from 'preact/hooks'

const UploadPhoto = ({ point, file, isUploadingPhoto, onUpload, onClose }) => {
  const [type, setType] = useState('original')
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)
  const [size, setSize] = useState(0)

  const [blob, setBlob] = useState()
  const [width2, setWidth2] = useState(0)
  const [height2, setHeight2] = useState(0)
  const [size2, setSize2] = useState(0)

  useEffect(() => {
    if (file) {
      const img = new Image()
      img.src = URL.createObjectURL(file)
      img.onload = () => {
        setWidth(img.width)
        setHeight(img.height)
        setSize(file.size)

        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        if (img.width > img.height) {
          canvas.width = 1000
          canvas.height = canvas.width * (img.height / img.width)
        } else {
          canvas.height = 1000
          canvas.width = canvas.height * (img.width / img.height)
        }
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

        canvas.toBlob(
          (blob) => {
            setBlob(blob)
            setSize2(blob.size)
            setWidth2(canvas.width)
            setHeight2(canvas.height)
          },
          'image/jpeg',
          0.75
        )
      }
    }
  }, [file])

  const handleSubmit = async () => {
    if (type === 'original' && file) {
      const newPoint = await uploadPhotoToPoint({ pointId: point.id, file })
      onUpload(newPoint)
    }
    if (type === 'lowres' && blob) {
      const newPoint = await uploadPhotoToPoint({ pointId: point.id, file: blob, name: file.name })
      onUpload(newPoint)
    }
  }

  return (
    <BasicDialog
      disableAutofocus
      title="Ladda upp foto"
      primaryActionText="Ladda upp"
      primaryActionLoading={isUploadingPhoto}
      onPrimaryActionClick={handleSubmit}
      action1Text="Avbryt"
      onAction1Click={onClose}
      onClose={onClose}
    >
      <img id="im" />
      <RadioButton
        name="type"
        value="original"
        checked={type === 'original'}
        label={`Orginal (${width}×${height}, ${formatSize(size)})`}
        onChange={() => setType('original')}
      />
      <SpacerVertical tiny />
      <RadioButton
        name="type"
        value="lowres"
        checked={type === 'lowres'}
        label={`Lågupplöst (${width2}×${height2}, ${formatSize(size2)})`}
        onChange={() => setType('lowres')}
      />
    </BasicDialog>
  )
}

const formatSize = (bytes) => {
  if (bytes > 1e6) {
    return (bytes / 1e6).toFixed(1) + 'MB'
  }
  if (bytes > 1e3) {
    return (bytes / 1e3).toFixed(1) + 'KB'
  }
  return bytes + 'B'
}

export default connect('project, isUploadingPhoto')(UploadPhoto)
